/**
 * 語言相關工具函數
 */

export const SUPPORTED_LANGUAGES = ['en', 'zh-tw', 'zh-cn', 'ja'] as const
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number]

/**
 * 將瀏覽器語言代碼映射到支援的語言
 */
const browserLangMap: Record<string, SupportedLanguage> = {
  'en': 'en',
  'en-US': 'en', 
  'en-GB': 'en',
  'zh': 'zh-tw',
  'zh-TW': 'zh-tw',
  'zh-CN': 'zh-cn',
  'zh-Hans': 'zh-cn',
  'zh-Hant': 'zh-tw',
  'ja': 'ja',
  'ja-JP': 'ja'
}

/**
 * 偵測使用者偏好語言
 * 優先順序: localStorage > 瀏覽器語言 > 預設語言
 */
export const detectUserLanguage = (): SupportedLanguage => {
  // 1. 從 localStorage 讀取用戶偏好
  if (typeof window !== 'undefined') {
    const savedLang = localStorage.getItem('preferred-language')
    if (savedLang && SUPPORTED_LANGUAGES.includes(savedLang as SupportedLanguage)) {
      return savedLang as SupportedLanguage
    }
  }

  // 2. 從瀏覽器語言推斷
  if (typeof navigator !== 'undefined') {
    const browserLang = navigator.language
    const mappedLang = browserLangMap[browserLang]
    if (mappedLang) {
      return mappedLang
    }
    
    // 嘗試語言代碼的主要部分 (例如 'en-AU' -> 'en')
    const primaryLang = browserLang.split('-')[0]
    const primaryMappedLang = browserLangMap[primaryLang]
    if (primaryMappedLang) {
      return primaryMappedLang
    }
  }

  // 3. 預設語言
  return 'en'
}

/**
 * 儲存使用者語言偏好
 */
export const saveUserLanguage = (language: SupportedLanguage): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('preferred-language', language)
  }
}